/**
 * Este código foi descontinuado
 * A geração da carteirinha está sendo feita direto do site da dental via webflow
 */
import React from 'react';
import urlBase from '../../url-base';
import axios from 'axios';
import InputMask from 'react-input-mask';
import {
  Alert, Container, Row, Col, Button, Collapse
} from 'reactstrap';
import {Link} from 'react-router';
import Footer from '../HomePageNew/Footer';
//import Contact from '../HomePageNew/Contact';
import { Scrollbars } from 'react-custom-scrollbars';
import Dialog from 'material-ui/Dialog';
import ReactToPrint from 'react-to-print';
import { List, ListItem } from 'material-ui/List';


class SearchForWallet extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      listDependent : [],
      removeContracts: [],
      collapse: false,
      openModal:false,
      planosAtivos:[],
      
    };
    this.toggle = this.toggle.bind(this);
    this.styles = {

    };
  }

  componentWillMount() {
  }

  componentDidMount() {
    //window.print = this.printRef.handlePrint;
    let oldPrintFunction = window.print;
    document.getElementById("alert_wallet_cpf").style.display = "none";
    document.getElementById('loading_wallet_cpf').style.display = 'none';

    window.print = function () {
      this.printRef.handlePrint
      oldPrintFunction();
    };
  }
  print(){
    this.printRef.handlePrint();
    //window.print = this.printRef.handlePrint;
    
    /* window.onafterprint = function() {
      document.getElementById("scrollbars_component").firstChild.style.position = 'absolute';
    };

    document.getElementById("scrollbars_component").firstChild.style.position = 'relative';

    window.print(); */
  }

  validateCpfContract(cpf) {
    //console.log(cpf);
    let	urlCpf = urlBase.loopBack+'APIS4s/ValidarCPF';
    let	dataPost = {
      cpf: cpf
    };

    let state = this.state;

    return axios.post(urlCpf, dataPost).then((result) => {
      if(result.data == null)
        return false;//retorna false, cpf nao encontrado
      else{
        //console.log(result);
        let contracts = result.data, cont=0;
        state.removeContracts = [];
        for(let i=0; i<contracts.length; i++){
          if(contracts[i].situacaoDescricao.indexOf("CANCELADO") == -1){
            cont++;                                    
          }
        }

        for (let i = 0; i < contracts.length; i++) {
          if (!contracts[i].situacao) {
            state.removeContracts.push(contracts[i].codigo);
            this.setState(state);
          }
        }

        if(cont > 0)
          return "PERMITIDO";
        else 
          return "CANCELADO";
      }
    })
    .catch(function (error) {
      alert("Erro", error);//alert erro caso seja informado cpf vazio ou invalido, para esse endpoint
    }.bind(this));
  }
  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  selectPlan(Item){
    //let position = result.data.length - 1;//pegando o ultimo contrato no array
    let state = this.state;
    state.listDependent = Item.Dependente;//ultimo contrato            
    this.setState(state);
    this.onOpenModal();
  }

  onOpenModal() {
    this.setState({ openModal: true });
  }
  onCloseModal() {
    this.setState({ openModal: false });
  }
	validateCpf(id, event){
    event.preventDefault();
    let cpf = document.getElementById(id).value.replace(/[^0-9]/g,'');
    document.getElementById('loading_wallet_cpf').style.display = 'block';

    let test = true;
    let add = 0, i = 0, rev = 0;

    if (cpf.length != 11 || 
        cpf == "00000000000" || 
        cpf == "11111111111" || 
        cpf == "22222222222" || 
        cpf == "33333333333" || 
        cpf == "44444444444" || 
        cpf == "55555555555" || 
        cpf == "66666666666" || 
        cpf == "77777777777" || 
        cpf == "88888888888" || 
        cpf == "99999999999"){
      test = false;
    }else{
      // Valida 1° digito	
      for (i=0; i < 9; i ++)		
        add += parseInt(cpf.charAt(i)) * (10 - i);	
        rev = 11 - (add % 11);	
        if (rev == 10 || rev == 11){		
          rev = 0;
        }	
        if (rev != parseInt(cpf.charAt(9))){		
          test = false;          	
        }	
      // Valida 2° digito	
      add = 0;	
      for (i = 0; i < 10; i ++){	
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }	
      rev = 11 - (add % 11);	
      if (rev == 10 || rev == 11){
        rev = 0;
      }	
      if (rev != parseInt(cpf.charAt(10))){
        test = false;
      }
    }
    if(test == true){
      document.getElementById("alert_wallet_cpf").style.display = "none";

      this.form_wallet();
    }else{
      document.getElementById('loading_wallet_cpf').style.display = 'none';
      document.getElementById("alert_wallet_cpf").innerHTML = "CPF inválido";
      document.getElementById("alert_wallet_cpf").style.display = "block";
    }
	}
	form_wallet(){
    let cpf = document.getElementById("wallet_cpf").value;
    
    this.validateCpfContract(cpf).then(cpfActive => {
      this.state.planosAtivos =[];
      this.setState(this.state);
      alert(cpf)
      if(cpfActive != false){//cpf encontrado
        if(cpfActive == "PERMITIDO"){
          let	url = urlBase.loopBack+'APIS4s/Associados';
          let	dataPost = {
            cpf  : cpf
          };

          axios.post(url, dataPost)
          .then((result) => {
            document.getElementById('loading_wallet_cpf').style.display = 'none';
            document.getElementById("alert_wallet_cpf").style.display = "none";

            let state = this.state;
            this.state.removeContracts;
            //BUG

            for (let i = 0; i < state.removeContracts.length; i++) {              
              let codeToRemove = state.removeContracts[i]; 
              for (let e = 0; e < result.data.length; e++) {
                let code = result.data[e].Dependente[0].Id;                
                if(code==codeToRemove){
                  result.data.splice(e, 1);
                }
              }
            }
            
            if (result.data.length>1){
              this.state.planosAtivos = result.data;
              this.setState(this.state);
              return false;
            }

            //console.log(result.data);
            // state.listDependent = result.data[position].Dependente;//ultimo contrato            
            let position = result.data.length - 1;//pegando o ultimo contrato no array
            state.listDependent = result.data[position].Dependente;//ultimo contrato            
            this.setState(state);
            this.onOpenModal();
          })
          .catch(function () {
            //alert(erro);
            document.getElementById('loading_wallet_cpf').style.display = 'none';
            document.getElementById("alert_wallet_cpf").innerHTML = "CPF não encontrado, entre em contado com a dental center através do número (83) 3041-4646";
            document.getElementById("alert_wallet_cpf").style.display = "block";
          });
        }else{
          document.getElementById('loading_wallet_cpf').style.display = 'none';
          document.getElementById("alert_wallet_cpf").innerHTML = "Contrato inativo para este cpf, entre em contado com a dental center através do número (83) 3041-4646";
          document.getElementById("alert_wallet_cpf").style.display = "block";
        }
      }else{
        document.getElementById('loading_wallet_cpf').style.display = 'none';
        document.getElementById("alert_wallet_cpf").innerHTML = "CPF não encontrado, entre em contado com a dental center através do número (83) 3041-4646";
        document.getElementById("alert_wallet_cpf").style.display = "block";
      }
    });    
  }

  render() {
    return (
      <div>
            {/* Retirar Menus 
            <MenuNew />        
            <NavbarDrop />
            */}

        <Container id="wallet_slip">
                 {/* Botão Voltar para o home */}
                 <Row style={{marginLeft: 80}}>
                      <Col style={{marginTop:30}} xs="12" sm="12" md="8" lg="8" xl="8">
                      <Link href="https://institucional.planodentalcenter.com.br/">
                                  <Button
                                              className="button_voltar"
                                              type="submit"
                                            >
                                          ← Voltar para Home
                                  </Button>                            
                          </Link>
                      </Col> 
                  </Row>          
          <div className="wallet_slip_img">
            
            <Row style={{marginRight: 0}}>
                          <Col style={{marginTop:10}} xs="12" sm="12" md="2" lg="2" xl="2">
                            <Row>
                                  <Col>
                                        {/* Imagens 3 */}
                                        <div className="wallet_slip_img_1">  </div>        

                                  </Col>
                              </Row>
                              <Row>
                                    <Col>
                                            {/* Imagens 2 */}
                                        <div className="wallet_slip_img_2">  </div>                     
                                    </Col>                                 
                            </Row>
               

                        </Col>               

              <Col id="wallet_slip_app_text" xs="12" sm="12" md="8" lg="8" xl="8">
                <h1>
                  Sua Carteirinha do Plano
                </h1>
                <p>
                  Baixe sua carteirinha vitual e tenha mais facilidade na hora das suas consultas
                </p>


                <form onSubmit={this.validateCpf.bind(this, "wallet_cpf")}>
                    <label>Insira o <b>CPF do titular</b> abaixo</label>
                    {this.state.planosAtivos.length > 0 ? (
                      <p>VOCÊ POSSUI MAIS DE UM PLANO ATIVO, SELECIONE ABAIXO</p>
                    ) : null}

                    <List>

                      {this.state.planosAtivos.map((item, i) => {
                        return <ListItem key={i} className='item_list' onClick={() => this.selectPlan(item)} primaryText={item.Dependente[0].NomePlano} />
                      })}

                    </List>  

                  <div>
                      <div id="loading_wallet_cpf">

                          <i className="fa fa-sync fa-spin"></i>
                          <span class="sr-only"> Aguarde...</span>                      
                      </div>
                      <br/>
                      <Alert  color='danger' styles={{ fontSize: 20 }} id="alert_wallet_cpf">{''}</Alert>

                      <InputMask
                        id="wallet_cpf"
                        className="ant-input input_second_wallet"
                        mask="999.999.999-99"
                        maskChar=" "
                        type="tel"
                        onBlur={this.validateCpf.bind(this, "wallet_cpf")}
                        placeholder="CPF DO TITULAR*"
                      />
                       &nbsp;&nbsp;&nbsp;&nbsp;
                      <Button
                            className="button_you_family"
                            onClick={this.validateCpf.bind(this, "wallet_cpf")}
                            type="submit"
                          >
                            Buscar
                      </Button>                      

                    </div>

                </form>
              </Col>

              <Col style={{marginTop:30}} xs="12" sm="12" md="2" lg="2" xl="2">
                            {/* Imagens 1 */}
                            <div className="wallet_slip_img_3"> </div> 
              </Col>            </Row>
          </div>

  
        </Container>

        <Dialog
          open={this.state.openModal}
          onRequestClose={this.onCloseModal.bind(this)}
          title={
            <div>
            <div className="logo_modal navbar-brand">&nbsp;</div>
            <i
              id="modal_wallet_slip_close_modal"
              className="fas fa-times-circle color_fa"
              onClick={this.onCloseModal.bind(this)}
            >{''}</i>
            <h2 className="modal_wallet_slip_title">Sua Carteirinha DENTAL CENTER</h2>
          </div>
          }
          contentStyle={{width: '90%',maxWidth: '100%'}}
        >
          <Scrollbars id="scrollbars_component" style={{ width: '100%', height: 400, padding: '0 8px' }}>
            <ReactToPrint
              ref={el => (this.printRef = el)}
              trigger={() => <span>{''}</span>}
              content={() => this.componentRef}
            />
              <div style={{marginBottom: 60}} ref={el => (this.componentRef = el)}>
                {this.state.listDependent.map((item, index) =>
                <div key={index}>
                  { index == 0 ? ( 
                  <div style={{marginBottom: 20}}>
                    <div id="print_card">
                      <div id="wallet">
                        <div className="margin">
                          <p className="card_wallet">{item.Id}</p>
                          <p className="card_wallet">{item.Nome}</p>
                          <p className="card_wallet">{item.NomePlano}</p>
                          <p className="card_wallet">{item.NomeEmpresa}</p>
                        </div>
                      </div>
                    </div>
                    <Row id="wallet_center">
                    <Col style={{marginTop:30}} xs="12" sm="12" md="4" lg="5" xl="4">
                        {''}
                    </Col>                     
 
                      <Col xs="12" sm="12" md="4" lg="5" xl="2" style={{marginTop: 20}}>
        
                          <div className="gradient-box" onClick={this.print.bind(this)}>
                             <div>Imprimir</div>
                          </div>

                      </Col>
                      <Col xs="12" sm="12" md="4" lg="5" xl="2" style={{marginTop: 20}}>
                      <div className="gradient-box" onClick={this.toggle.bind(this)}>
                             <div>DEPENDENTES</div>
                      </div>                     
  
                      </Col>
                      <Col xs="12" sm="12" md="4" lg="5" xl="5" style={{marginTop: 20}}>
                          {''}
                      </Col>                      
                    </Row>
                  </div>
                        ):(
                  <Collapse isOpen={this.state.collapse} style={{marginTop: 20}}>
                    <div id="print_card">
                      <div id="wallet">
                        <div className="margin">
                          <p className="card_wallet">{item.Id}</p>
                          <p className="card_wallet">{item.Nome}</p>
                          <p className="card_wallet">{item.NomePlano}</p>
                          <p className="card_wallet">{item.NomeEmpresa}</p>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                        )
                    }
                </div>
                )}
              </div>
          </Scrollbars>
        </Dialog>
        {/* Retirar a seção de contatos da página 
        <Contact />
        */}
        <Footer />
      </div>

    );
  }
}
export default SearchForWallet;



/** WEBPACK FOOTER **
 ** ./src/components/LittleWalletNew/SearchForWallet.js
 **/